import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Col, Row } from 'react-styled-flexboxgrid';
import { MOBILE_END_QUERY } from '../../../styling/mixins/responsive';
import HoverImage from './HoverImage';

const Asset = styled(Col)`
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 400px) {
    &:first-child {
      margin-left: 0.5rem;
    }
  }
`;

const StyledRow = styled(Row)`
  overflow-x: auto;
  padding-top: 1rem;

  @media (${MOBILE_END_QUERY}) {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
`;

function renderImage({ src, hoverSrc }) {
  return <HoverImage src={src} hoverSrc={hoverSrc} />;
}

export default class AssetRow extends Component {
  static propTypes = {
    assets: PropTypes.array.isRequired,
    renderAsset: PropTypes.func.isRequired,
  };

  static defaultProps = {
    renderAsset: renderImage,
    colProps: {
      xs: 5,
      sm: 4,
      md: 2,
    },
  };

  render() {
    const { assets, renderAsset, colProps } = this.props;

    return (
      <StyledRow>
        {assets.map((asset, index) => {
          return (
            <Asset key={index} {...colProps}>
              {renderAsset(asset)}
            </Asset>
          );
        })}
      </StyledRow>
    );
  }
}
